export default __webpack_public_path__ + "static/media/turismo.f5d3853b.svg";